export default function InventoryMeter({ claimed, total, remaining, className = "" }) {
  const pct = total ? Math.round((claimed / total) * 100) : 0;
  const low = remaining <= total * 0.15;
  return (
    <div className={className} data-testid="inventory-meter">
      <div className="h-2 w-full bg-stone-100 rounded-full overflow-hidden">
        <div className="h-full rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, background: low ? "linear-gradient(90deg,#f59e0b,#ef4444)" : "linear-gradient(90deg,#10b981,#f59e0b)" }} />
      </div>
      <p className={`mt-1.5 text-xs font-semibold ${low ? "text-red-500" : "text-stone-500"}`}>
        {remaining} Friibs left · {pct}% claimed
      </p>
    </div>
  );
}
